import { GOOGLE_SPACING } from 'app/const';
import { CLASS_ASIDE_PANEL } from '../../constants';

export const CLASS_ASIDE_PANEL_HEADER = CLASS_ASIDE_PANEL + '__header';
export const HEADER_HEIGHT = GOOGLE_SPACING * 7; // для AsidePanel isActionsScticky
